import { request, requestFile } from '../@utils'
const Service = {
  getList: async req =>
    await request.post('report/product-sale/list', { data: req }),
  getTaxRates: async id => await request.get(`report/product-sale/taxRates`),
  getStore: async () => await request.post(`common/store/list`),
  export: async req =>
    await requestFile.post('report/product-sale/export', { data: req }, { type: 'blob' }),
}

export default Service
